import request from '@/utils/request2'

// 列表(主数据列表)
export function loadMarketReportListDataApi (data) {
  return request({
    url: 'tms-web/marketReport/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportMarketReportListDataApi (data) {
  return request({
    url: 'tms-web/marketReport/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/save',
    method: 'post',
    data
  })
}

// 修改
export function updateMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/update',
    method: 'post',
    data
  })
}

// 发送到AI进行数据分析
export function sendMarketReportToAIApi (data) {
  return request({
    url: 'tms-web/marketReport/sendDataToAi',
    method: 'post',
    data,
    timeout: 300000
  })
}

// 更改状态
export function updateMarketReportStatusApi (data) {
  return request({
    url: 'tms-web/marketReport/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deleteMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/view',
    method: 'post',
    data
  })
}

// 验证周报数据
export function verifyMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/verify',
    method: 'post',
    data
  })
}

// 获取已存在的周报
export function listExistMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/listExist',
    method: 'post',
    data
  })
}

// 下载周报JSON数据
export function downloadJsonMarketReportApi (data) {
  return request({
    url: 'tms-web/marketReport/downloadJsonData',
    method: 'post',
    data
  })
}
